/**
 * Public customer-facing booking website.
 * Every link sent to guests (SMS, email, QR codes, payment / ticket / invitation links)
 * must be built from this constant.
 */
export const PUBLIC_SITE_URL = 'https://tixntrx.com';
